export const USER_EVENTS_NEWS_REQUEST = "USER_EVENTS_NEWS_REQUEST";
export const USER_EVENTS_NEWS_SUCCESS = "USER_EVENTS_NEWS_SUCCESS";
export const USER_EVENTS_NEWS_FAIL = "USER_EVENTS_NEWS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 